import React, { useEffect, useMemo } from 'react';

import Polling from 'handshq-app/utilities/polling';
import PropTypes from 'prop-types';

import { useBreadBoard } from 'components/contexts/Toaster';
import Image from 'components/training/attachments/components/Image';
import Settings from 'components/training/attachments/components/Settings';

import Upload from 'components/helpers/Upload';

export default function Viewer({
  attachment,
  index,
  onCreate,
  onDelete,
  onPollingSuccess,
  onRotateClick,
  onRotateSuccess,
}) {
  const { addInedibleToast } = useBreadBoard();

  const {
    attachedProcessed: isProcessed,
    file,
    hashid,
    key,
    originalImageThumbUrl,
  } = attachment;

  const upload = useMemo(
    () =>
      file &&
      new Upload({
        file,
        onUpload: (fileType, uploadKey) => {
          onCreate({ attachment, fileType, uploadKey });
        },
        onError: addInedibleToast,
      }),
    [file],
  );

  const polling = useMemo(
    () =>
      hashid &&
      new Polling({
        interval: 1000,
        maxTime: 600000,
        url: `/attachments/${hashid}`,
        responseCheck: (response) =>
          response.data.attributes.attachedProcessed === true,
        successCallback: (response) =>
          onPollingSuccess({ response, attachment }),
        failureCallback: () => addInedibleToast(),
      }),
    [hashid],
  );

  useEffect(
    () => () => {
      polling && polling.end();
    },
    [],
  );

  useEffect(() => {
    file && upload.start();
  }, []);

  useEffect(() => {
    !file && !isProcessed && !originalImageThumbUrl && polling.start();
  }, [file]);

  return (
    <div
      className='attachments__item attachments__item--compact-mode'
      id={`attachments__item-${key}`}
    >
      <div className='attachments__viewer tw-border-grey-100 tw-bg-white'>
        <Image attachment={attachment} />
        <Settings
          attachment={attachment}
          index={index}
          onDelete={() => {
            if (polling) polling.end();
            onDelete({ attachment });
          }}
          onRotateClick={onRotateClick}
          onRotateSuccess={onRotateSuccess}
        />
      </div>
    </div>
  );
}

Viewer.propTypes = {
  attachment: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onCreate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPollingSuccess: PropTypes.func.isRequired,
  onRotateClick: PropTypes.func.isRequired,
  onRotateSuccess: PropTypes.func.isRequired,
};
